import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 32557 48989"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:709.99}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970270452608">
        <path
          d="M1646 7828C-1114 5071 839 355 4742 355h23074c3900 0 5853 4716 3096 7473L18744 19996c-1361 1361-3569 1361-4930 0L1646 7828zM1646 35446c-2760-2757-807-7473 3096-7473h23074c3900 0 5853 4716 3096 7473L18744 47614c-1361 1360-3569 1360-4930 0L1646 35446z"
          className="fill stroke1s"
          style={{
            strokeWidth: 709.99,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
